import { Observable } from 'rxjs';

import { AppStore } from '~/types/main.types';

import { CloseFilterPanel, EditorActionType, OpenFilterPanel } from '../../actions/editor-actions';
import { StoreConnector } from '../../common/store-connector';
import { ModeApp } from '../../reducers/index';

/**
 * Filter Panel Toggler Controller
 *
 * Toggle state of the filter panel with given state or
 * default to redux {StoreService}
 */
export default class FilterPanelTogglerController {
  static $inject = ['RxStoreService', 'StoreService'];

  private filterPanelIsOpen$: Observable<boolean>;
  private onToggle: ($args: { $state: boolean }) => void;
  private isInReportViewer = false;

  constructor(
    private rxStore: AppStore,
    private store: StoreConnector<ModeApp>
  ) {
    this.filterPanelIsOpen$ = rxStore.select('transient', 'editor', 'isFilterPanelOpen');
  }

  handleClick(open: boolean) {
    this.rxStore.dispatch({
      type: EditorActionType.OverrideFilterPanel,
      isOpen: !open,
    });

    // to maintain backwards compatibility
    this.setFilterPanelDisplayState(!open);
    this.onToggle({ $state: !open });
  }

  setFilterPanelDisplayState(isOpen) {
    if (isOpen) {
      this.store.dispatch(OpenFilterPanel());
    } else {
      this.store.dispatch(CloseFilterPanel());
    }
  }
}
